import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
// import Lottie from 'react-lottie'
import { statusHtmlStorage } from '../config/helper'
// import wave from '../assets/lottie/wave.json'


function LayoutComponent({children}) {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (
      ['/signin', '/signup', '/forgot-password'].includes(location.pathname) &&
      statusHtmlStorage('accessToken')
    ) {
      navigate('/')
    }
  })

  return (
    <>
      {/* <div className="custom-wave">
        <Lottie
          options={{
            loop: false,
            autoplay: false,
            animationData: wave,
          }}
        />
      </div> */}
      {children}
    </>
  )
}

export default LayoutComponent
